<template>
  <div class="footer flex a-center j-center text-white fs-12">
    <span class="m-h-15">
      <span class="m-r-5">©{{ year }}</span>
      <span v-for="(copyright, index) in configuration.$copyrights" :key="`copyright-${index}`">
        <span v-if="index" class="sep">|</span>
        <a :href="copyright.link" target="_blank" class="link text-white">{{ copyright.name }}</a>
      </span>
      <span><span v-if="configuration.$copyrights.length > 1">联合</span>出品</span>
    </span>
    <span class="m-h-15">
      <span v-for="(icp, index) in configuration.$icps" :key="`icp-${index}`">
        <span v-if="index" class="sep">|</span>
        <span>{{ icp }}</span>
      </span>
    </span>
  </div>
</template>

<script>
import configuration from '/src/AIConfig'
export default {
  data () {
    return {
      year: new Date().getFullYear(),
      configuration
    }
  },
}
</script>


<style lang="scss" scoped>
.sep {
  margin: 0 2px;
}
a {
  text-decoration: none;
}
@media (max-width: 767px) {
  .m-h-15 {
    margin: 0 10px;
  }
  .flex {
    flex-wrap: wrap;
  }
}
</style>
